export enum RoleEnum {
  ADMIN = '00001',
  STUDENT = '00002',
}

export enum MessageTypeEnum {
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  PHOTO = 'PHOTO',
  AUDIO = 'AUDIO',
  FILE = 'FILE',
  EMOTION = 'EMOTION',
  LOCATION = 'LOCATION',
}

export enum FileTypeExtEnum {
  PNG = 'image/png',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  GIF = 'image/gif',
}

export enum ContentTypeEnum {
  FORM_DATA = 'multipart/form-data',
}
